<div class="modal-content">
  <div class="modal-header bg-tertiary">
    <h6 class="modal-title fw-bold" id="addConfigurationModalLabel">Search and replace</h6>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-6">
        <label for="search" class="form-label fw-bold small">Text to search</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-search"></i></span>
          <input [(ngModel)]="search" placeholder="Text to search" class="form-control" id="search"/>
        </div>
      </div>

      <div class="col-6">
        <label for="replace" class="form-label fw-bold small">Text to replace</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-text-wrap"></i></span>
          <input [(ngModel)]="replace" placeholder="Text to replace" class="form-control" id="replace"/>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-6">
        <app-input-switch [(ngModel)]="caseSensitive">Case sensitive</app-input-switch>
      </div>

      <div class="col-6">
        <button (click)="searchAll()" class="btn btn-info text-light w-100" type="button">
          <i class="bi bi-text-paragraph me-3"></i>Simulate
        </button>
      </div>
    </div>

    @if (translations.length) {
      <div class="row mt-4">
        <div class="col">
          <div class="table-responsive" style="max-height: 450px;">
            <table class="table table-hover table-striped-columns">
              <thead>
                <tr>
                  <th>Found</th>
                  <th>Result after replace</th>
                </tr>
              </thead>
              <tbody>
                @for (translation of translations; track translation) {
                  <tr>
                    <td><code>{{ translation.key }}</code></td>
                    <td>{{ translation.text }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="modal-footer bg-tertiary">
    <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>
    <button (click)="replaceAll()" type="button" class="btn btn-primary fw-bold" appConfirm>Replace all</button>
  </div>
</div>
